export default "__VITE_ASSET__fa9a643f__"